/**
 * Utilities for using `effect` to work with files and directories.
 *
 * @module @sorrell/utilities/fs/effect
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * from "./FileSystem.Effect.ts";
